import zipcodes, { type ZipCode } from 'zipcodes'

export const parseZipCode = (value: string): ZipCode | undefined => {
  if (value.length < 5) {
    return
  }
  const zip = value.slice(0, 5)
  return zipcodes.lookup(zip)
}
